import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import DeepServiceCityPage from '../../components/templates/DeepServiceCityPage';
import KitchenCityPage from '../../components/templates/KitchenCityPage';
import ServiceCityPageTemplate from '../../components/templates/ServiceCityPageTemplate';
import { getCity, hasServiceCityPage } from '../../data/cities';
import { getKitchenCityContent } from '../../data/kitchenCityPages';
import { getServiceCityDeep } from '../../data/serviceCityDeep';
import { getServiceGuide } from '../../data/serviceGuides';
import { getService } from '../../data/services';
import { locationPath, ROUTES, servicePath } from '../../enum/routes';

export default function ServiceCityPage() {
  const { serviceSlug, citySlug } = useParams<{ serviceSlug: string; citySlug: string }>();
  const service = serviceSlug ? getService(serviceSlug) : undefined;
  const city = citySlug ? getCity(citySlug) : undefined;

  if (!service) return <Navigate to={ROUTES.SERVICE_AREAS} replace />;
  if (!city) return <Navigate to={servicePath(service.slug)} replace />;
  if (!hasServiceCityPage(service.slug, city.slug)) {
    return <Navigate to={locationPath(city.slug)} replace />;
  }

  const kitchenContent =
    service.slug === 'kitchen-remodeling' ? getKitchenCityContent(city.slug) : undefined;
  if (kitchenContent) {
    return <KitchenCityPage service={service} city={city} content={kitchenContent} />;
  }

  const deep = getServiceCityDeep(service.slug, city.slug);
  const guide = getServiceGuide(service.slug);
  if (deep && guide) {
    return <DeepServiceCityPage service={service} city={city} content={deep} guide={guide} />;
  }

  return <ServiceCityPageTemplate service={service} city={city} />;
}
